import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import R from 'ramda'

import { 
  postsEnhancer 
} from 'utils/enhancers'
import Difficulty from 'components/Difficulty'
import Title from 'components/Title'

const BlogPostTemplate = ({ 
  frontmatter,
  html,
  siteTitle,
  image
}) => (
  <div className='max-width-2 mx-auto px2 mb3'>
    <Helmet title={`${frontmatter.title} | ${siteTitle}`} />
    
    <Title>
      {frontmatter.title}
    </Title>
    
    <Difficulty 
      frontmatter={frontmatter} 
      className='mb2'
    />
    
    <div dangerouslySetInnerHTML={{ __html: html }} />
    
    {image && (
      <img 
        src={image} 
        className='fit block'
      />
    )}
    
  </div>
)

export default postsEnhancer(BlogPostTemplate)

export const pageQuery = graphql`
  query LessonPostByPath($path: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      id
      html
      frontmatter {
        title
        date
        caption
        difficulty
        image {
          childImageSharp {
            responsiveSizes(maxWidth: 2500, quality: 70) {
              src
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/area.js